import ModalDrawer from '@stone/components/modal/ModalDrawer';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { compositionAndCareTextSelector, stylistNoteTextSelector } from '@common/state/features/product.selectors';
import Accordion from '@common/ui/accordion/Accordion';
import AccordionItem from '@common/ui/accordion/AccordionItem';
// import analytics from '@common/utils/analytics';
import ReactHtmlParser from 'react-html-parser';
// import SizeGuide from '@stone/components/sizeguide/SizeGuide';
// import SizeGuideButton from '@stone/components/sizeguide/SizeGuideButton';
// import Button from '@stone/ui/button/Button';
import Image from '@stone/ui/image/Image';
import customEventBus from '@common/scripts/libs/eventBus';
import ProductDetailsEditorials from './ProductDetailsEditorials';
const EVENTNAME = 'productdetails';
export const requestProductDetailsOpen = (target, originalEvent) => {
    customEventBus.emit(EVENTNAME, {
        action: 'open',
        target,
        originalEvent,
    });
};
const ProductDetailsDialog = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { t } = useTranslation();
    const compositionAndCareText = useSelector(compositionAndCareTextSelector);
    const stylistNoteText = useSelector(stylistNoteTextSelector);
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const opener = useRef(null);
    const printValues = (attr) => {
        if (!attr) {
            return React.createElement(React.Fragment, null);
        }
        return attr.attributes.map((items) => items === null || items === void 0 ? void 0 : items.value.map((item) => (item.type === 'image' ? React.createElement("img", { key: item.url, src: item.url, alt: item.alt || '' }) : React.createElement("div", { key: item }, ReactHtmlParser(item)))));
    };
    const shippingAndReturns = useMemo(() => {
        var _a;
        return (_a = props.componentsDrawer) === null || _a === void 0 ? void 0 : _a.find((com) => com.typeid == 'component_pdp_return');
    }, [props.componentsDrawer]);
    const specialServicesPdp = useMemo(() => {
        var _a;
        return (_a = props.componentsDrawer) === null || _a === void 0 ? void 0 : _a.find((com) => com.typeid == 'component_pdp_specialservices');
    }, [props.componentsDrawer]);
    const handleClose = () => {
        props.handleClose && props.handleClose();
        setIsOpen(false);
        setTimeout(() => {
            var _a;
            (_a = opener.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
    };
    const printValuesCare = () => {
        var _a, _b;
        const compositionAndCare = (_a = props.product) === null || _a === void 0 ? void 0 : _a.compositionAndCare;
        if (!compositionAndCare) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", null,
            compositionAndCare.showCareDescription && compositionAndCare.care ? React.createElement("p", { className: "care-description" }, compositionAndCare.care || '') : React.createElement(React.Fragment, null),
            React.createElement("p", { className: "mt-24 composition-description" }, compositionAndCare.composition || ''),
            React.createElement("ul", { className: "composition-care-icons-container mt-40" }, (_b = compositionAndCare.icons) === null || _b === void 0 ? void 0 : _b.map((e) => (React.createElement("li", { className: "composition-care-icons", key: e.url },
                React.createElement("img", { src: e.url, alt: e.description }),
                React.createElement("span", null, e.description || '')))))));
    };
    useEffect(() => {
        let handler = (data) => {
            var _a;
            if (data.action == 'open') {
                opener.current = (_a = data.originalEvent) === null || _a === void 0 ? void 0 : _a.target;
                setIsOpen(data.target || true);
            }
            else {
                setIsOpen(false);
            }
        };
        customEventBus.on(EVENTNAME, handler);
        return () => {
            customEventBus.off(EVENTNAME, handler);
        };
    }, []);
    if (!(props === null || props === void 0 ? void 0 : props.product))
        return React.createElement(React.Fragment, null);
    return (React.createElement(ModalDrawer, { isOpen: !!isOpen, onRequestClose: handleClose, contentLabel: props.product.productName, id: "product-details-modal" },
        React.createElement("div", { className: "product-details" },
            React.createElement(Accordion, { gap: 20 },
                React.createElement(AccordionItem
                // callbackOnOpen={() => detectAccordionOpen(compositionAndCareText?.name, props.product.id)}
                , { 
                    // callbackOnOpen={() => detectAccordionOpen(compositionAndCareText?.name, props.product.id)}
                    title: t('product.fabricandresearch'), headerClass: "accordion__header--uc", accordionId: "fabric-research", isInitialOpen: typeof isOpen !== 'string' },
                    React.createElement("p", null, props.product.longDescription),
                    ((_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.pdpIcons) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement("ul", { className: "icons-list" }, props.product.pdpIcons.map((el) => (React.createElement("li", { key: el.label },
                        React.createElement(Image, { src: el.path, alt: el.label }))))))),
                ((_c = stylistNoteText === null || stylistNoteText === void 0 ? void 0 : stylistNoteText.attributes) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement(AccordionItem
                // callbackOnOpen={() => detectAccordionOpen('styleAndFitText', props.product.id)}
                , { 
                    // callbackOnOpen={() => detectAccordionOpen('styleAndFitText', props.product.id)}
                    title: t('product.styleandfit'), headerClass: "accordion__header--uc", accordionId: "styleAndFit" },
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: (_d = stylistNoteText === null || stylistNoteText === void 0 ? void 0 : stylistNoteText.attributes[0]) === null || _d === void 0 ? void 0 : _d.value[0] } })))),
                React.createElement(AccordionItem
                // callbackOnOpen={() => detectAccordionOpen(compositionAndCareText?.name, props.product.id)}
                , { 
                    // callbackOnOpen={() => detectAccordionOpen(compositionAndCareText?.name, props.product.id)}
                    title: compositionAndCareText === null || compositionAndCareText === void 0 ? void 0 : compositionAndCareText.name, headerClass: "accordion__header--uc", accordionId: "composition-care" },
                    React.createElement(React.Fragment, null,
                        printValuesCare(),
                        React.createElement("p", { className: "mt-12" },
                            t('product.styleno'),
                            " ",
                            props.product.id),
                        props.product.madeIn && React.createElement("p", null, props.product.madeIn),
                        props.product.firstProductDate && (React.createElement("p", null,
                            t('product.productmanufactored'),
                            " ",
                            props.product.firstProductDate)),
                        props.product.importedBy && React.createElement("p", null, props.product.importedBy),
                        ((_e = props.product) === null || _e === void 0 ? void 0 : _e.traceability) && ((_f = props.product) === null || _f === void 0 ? void 0 : _f.traceability.url) && (React.createElement("div", { className: "composition-care_agec" },
                            React.createElement("p", { className: "font__subtitle", id: "composition-care_agec" }, t('product.compositionandcaretraceabilitytitle')),
                            React.createElement("p", null,
                                t('product.compositionandcaretraceability'),
                                ' ',
                                React.createElement("a", { href: props.product.traceability.url, target: "_blank" }, t('product.compositionandcaretraceabilitycta'))))))),
                !((_g = props.product) === null || _g === void 0 ? void 0 : _g.notShoppable) && shippingAndReturns && (React.createElement(AccordionItem
                // callbackOnOpen={() => detectAccordionOpen(shippingAndReturns?.name, props.product.id)}
                , { 
                    // callbackOnOpen={() => detectAccordionOpen(shippingAndReturns?.name, props.product.id)}
                    title: shippingAndReturns === null || shippingAndReturns === void 0 ? void 0 : shippingAndReturns.name, headerClass: "accordion__header--uc", accordionId: "shipping-returns", isInitialOpen: isOpen === 'delivery' },
                    React.createElement("div", { className: "pdp-drawer-ca" },
                        React.createElement(ProductDetailsEditorials, { content: shippingAndReturns })))),
                !((_h = props.product) === null || _h === void 0 ? void 0 : _h.notShoppable) && specialServicesPdp && (React.createElement(AccordionItem
                // callbackOnOpen={() => detectAccordionOpen(specialServicesPdp?.name, props.product.id)}
                , { 
                    // callbackOnOpen={() => detectAccordionOpen(specialServicesPdp?.name, props.product.id)}
                    title: specialServicesPdp === null || specialServicesPdp === void 0 ? void 0 : specialServicesPdp.name, headerClass: "accordion__header--uc", accordionId: "special-services", isInitialOpen: isOpen === 'special-services' },
                    React.createElement("div", { className: "pdp-drawer-ca" },
                        React.createElement(ProductDetailsEditorials, { content: specialServicesPdp }))))))));
};
export default ProductDetailsDialog;
